const countUnreadMessages = (chats) => {
  if(!chats) return 0;

  return chats.reduce((acc, chat) => {
    return acc + chat.unreadMessagesForCRM
  }, 0)
};

export default countUnreadMessages;